// 推送埋点事件到 dataLayer，由 GTM 转发到 GA4 等平台。
// 事件名约定 tb_ 前缀（taiwan business）便于 GTM 触发器统一过滤。
export function trackEvent (event, params = {}) {
  if (!window.dataLayer) return
  window.dataLayer.push({ event, ...params })
}

// 注册等紧接整页跳转的事件需等待处理完成；回调仅表示标签处理结束，不代表 Ads 已归因。
export function trackEventAndWait (event, params = {}) {
  if (typeof window === 'undefined') return Promise.resolve()
  const useGtag = typeof window.gtag === 'function'
  if (!useGtag && !(window.dataLayer && typeof window.dataLayer.push === 'function')) return Promise.resolve()

  return new Promise(resolve => {
    let finished = false
    const done = () => {
      if (finished) return
      finished = true
      clearTimeout(timer)
      resolve()
    }
    // 独立于 GTM 的兜底：脚本被拦截、仅有队列或标签没有回调时，也不能卡住注册。
    const timer = setTimeout(done, 2000)
    try {
      if (useGtag) {
        window.gtag('event', event, { ...params, event_callback: done, event_timeout: 2000 })
      } else {
        window.dataLayer.push({ ...params, event, eventCallback: done, eventTimeout: 2000 })
      }
    } catch (error) {
      // 埋点异常不能把已成功的注册变成失败，也不重发以免重复转化。
      done()
    }
  })
}
